import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AuthModule } from '../../../auth/auth.module';
import { StripePaymentComponent } from './stripe.payment.component';
import { FormsModule } from '@angular/forms';
import {ImgSrcPrefixPipeModule} from '../../pipes/imgsrcprefix.pipe/img.src.pipe.module';

@NgModule({
    declarations: [StripePaymentComponent],
    imports: [BrowserModule, AuthModule, FormsModule, ImgSrcPrefixPipeModule],
    exports: [StripePaymentComponent]
})

export class CardPaymentModule { }


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/components/common/card.payment/card.payment.module.ts